import type { CopilotChatInputProps } from '@copilotkit/react-core/v2';
import { InkAiChatInput } from '@movable/ui';
import { Box } from '@mui/material';

export type InkChatInputSlotProps = CopilotChatInputProps & {
  placeholder?: string;
  disabled?: boolean;
};

export const InkChatInputSlot = ({
  value,
  onChange,
  onSubmitMessage,
  onStop,
  isRunning,
  autoFocus,
  placeholder,
  disabled,
}: InkChatInputSlotProps) => (
  <Box sx={{ p: 2 }}>
    <InkAiChatInput
      value={value ?? ''}
      onChange={(next) => onChange?.(next)}
      onSubmit={(next) => onSubmitMessage?.(next)}
      onStop={onStop}
      isGenerating={isRunning}
      autoFocus={autoFocus}
      placeholder={placeholder}
      scopeOptions={[]}
      disabled={disabled}
    />
  </Box>
);
